module.exports = __webpack_public_path__ + "img/self_publisher.0f4cb8f9.svg";